import { $, $$ } from '@3pc/dom';
import { Player } from '@3pc/player-videojs';
import { Accordion } from '@3pc/accordion';

const players = document.querySelectorAll('.video-player--mp4');

const playerConfig = {
  // These are the default options (if these suit your purpose the config object can be left empty - else you can overwrite them here or add more options):
};

players.length &&
  players.forEach(playerEl => {
    new Player({
      player: playerEl,
      config: playerConfig,
    }).init();
  });

// accordion selector (secect the elemet that contains the handler and target for each accordion)
const accordionItems = $$('.video-player__content');

const initAccordion = container => {
  // handler is the button (burger, close, menu etc.)
  const handler = $('.video-player__content-trigger', container);
  // target is the element that should be opened/closed
  const target = $('.video-player__content-panel', container);
  // target is the element that should be opened/closed
  const targetInner = $('.video-player__content-panel-inner', target);

  // if no handler, target or targetInner is found, return
  if (!handler || !target || !targetInner) return;

  // initialize accordion with options
  const accordion = new Accordion({
    target,
    targetInner,
    handler,
    easing: 'easeInOutQuart',
    duration: 400,
    initOpened: false,
    openClassName: 'is-open',
  });
  accordion.init();
};

// loop over each accordion item and initialize it
accordionItems.forEach(accordionItem => {
  return initAccordion(accordionItem);
});
